import React from 'react';
import { X } from 'react-feather';

const Select = ({ label, name, required, value = -1, onChange, options, error, disabled = false, cleanContent = false, width = '200px', className }) => {

  React.useEffect(() => {
  }, [value])

  return (
    <div className={`label-filter${error && ' field-error'}`}>
        <label htmlFor={name} className={`${required && "required"}`} style={{fontSize: '14px'}}>{label}</label>
        <br/>
        <select
          className={className}
          style={{width: width}}
          defaultValue={value}
          disabled={disabled}
          onChange={onChange}>
            <option value={-1} disabled>Selecione</option>
            {options.map((option, index) =>
            <option key={option.id} value={option.id}>
                {option.name}
            </option>
            )}
        </select>
        {cleanContent && <span className="close-icon-picker-date" onClick={() => onChange({target: {value: -1}})}><X /></span>}
        {error && <p className='error-field'>{error}</p>}
    </div>
  );
};

export default Select;